import { isAfter, isBefore, isEqual } from 'date-fns';

/**
 * Checks if a date is within a specified range.
 *
 * @param {Date} date - The date to check.
 * @param {Date | undefined} min - The minimum date of the range (inclusive). If undefined, no lower bound.
 * @param {Date | undefined} max - The maximum date of the range (inclusive). If undefined, no upper bound.
 * @returns {boolean} - Indicates whether the date is within the range.
 */
export const isDateInRange = (date: Date, min?: Date, max?: Date): boolean => {
  const isAfterMin = !min || isEqual(date, min) || isAfter(date, min);
  const isBeforeMax = !max || isEqual(date, max) || isBefore(date, max);
  return isAfterMin && isBeforeMax;
};
